import { computed, MaybeRefOrGetter, toValue } from 'vue';
import { __ } from '@/js/stores/expressions';
import { usePermissions } from './usePermissions';
import { PermissionArea, QualityAssuranceModulePermissionFlag } from '@/js/consts/permissions';

type LockableProtocol = {
    isSyncedFromV1?: boolean;
    requiresApproval?: boolean;
    approved?: boolean | null;
};

/** Why a protocol can't be changed, or null when it can. */
export function useProtocolLock(protocol: MaybeRefOrGetter<LockableProtocol | undefined>) {
    const { hasPermission } = usePermissions();
    const canApproveProtocols = hasPermission(
        PermissionArea.QualityAssuranceModule,
        QualityAssuranceModulePermissionFlag.ApproveProtocols
    );

    const lockReason = computed<string | null>(() => {
        const p = toValue(protocol);
        if (!p) return null;
        if (p.isSyncedFromV1) return __('protocol-synced-from-v1-tooltip');
        if (p.requiresApproval && p.approved === false && !canApproveProtocols.value) {
            return __('protocol-pending-approval-tooltip');
        }
        return null;
    });

    return { lockReason };
}
